import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import ProgrssBar from "../ProgressBar";
import ConfirmDialog from "../ConfirmDialog";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Checkbox,
  FormControlLabel,
  Chip,
  Box,
  Menu,
  MenuItem,
  Divider,
  FormGroup,
  TextField,
  Fab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import grey from "@material-ui/core/colors/grey";
import primaryColor from "@material-ui/core/colors/indigo";
import Alert from "@material-ui/lab/Alert";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import DialogContentText from "@material-ui/core/DialogContentText";
import CircularProgress from "@material-ui/core/CircularProgress";
import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";
import SyncOutlinedIcon from "@material-ui/icons/SyncOutlined";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import DomainDisabledIcon from "@material-ui/icons/DomainDisabled";
import RestoreIcon from "@material-ui/icons/Restore";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import FullscreenIcon from "@material-ui/icons/Fullscreen"; // Import Maximize icon

const TableHeaderCell = withStyles({
  root: {
    background: primaryColor[500],
    borderRadius: 8,
    border: 0,
    color: "white",
    height: 45,
    boxShadow: "0 3px 5px 2px rgba(28, 10, 120, .3)",
  },
})(TableCell);

const SlimsPrc = () => {
  const [loaded, setLoaded] = useState(false);
  const [progress, setProgress] = useState(false);
  const [slimsPrcData, setSlimsPrcData] = useState([]);
  const [showBannerType, setShowBannerType] = useState("");
  const [status, setStatus] = useState(false);
  const [statusText, setStatusText] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectAllButtonText, setSelectAllButtonText] = useState("Select All");
  const [sbluTriggerValues, setSbluTriggerValues] = useState({});
  const [pendingPortChanges, setPendingPortChanges] = useState({});
  const [pendingSubPortLimitChanges, setPendingSubPortLimitChanges] =
    useState({});
  const [applyLoading, setApplyLoading] = useState(false);
  const [originalPorts, setOriginalPorts] = useState({});
  const [selectedBox, setSelectedBox] = useState(null);
  const [selectedSubPort, setSelectedSubPort] = useState(null);
  const [checkedPorts, setCheckedPorts] = useState([]);
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [availableBoxes, setAvailableBoxes] = useState([]);
  const [newBox, setNewBox] = useState("");
  const [newSubPorts, setNewSubPorts] = useState([]);
  const [newPorts, setNewPorts] = useState({});
  const [newSubPortLimits, setNewSubPortLimits] = useState({});
  const [newSbluTriggerIn, setNewSbluTriggerIn] = useState(3);
  const [newGlobalLimit, setNewGlobalLimit] = useState(1);
  const [newFullDayLimit, setNewFullDayLimit] = useState(3);
  const [addError, setAddError] = useState("");
  const [portMenusAnchor, setPortMenusAnchor] = useState({});
  const [portMenusOpen, setPortMenusOpen] = useState("");
  const [newSblu, setNewSblu] = useState(undefined);
  const [prcStatus, setPrcStatus] = useState(null);
  const [actionStatus, setActionStatus] = useState("");
  const [actionStatusType, setActionStatusType] = useState("");
  const [actionStatusTimeout, setActionStatusTimeout] = useState(null);
  const [boxOrder, setBoxOrder] = useState([]);
  const [showReorderDialog, setShowReorderDialog] = useState(false);
  const [reorderLoading, setReorderLoading] = useState(false);
  const [syncStatus, setSyncStatus] = useState(null);
  const [syncLoading, setSyncLoading] = useState(false);
  const [syncingNow, setSyncingNow] = useState(false);
  const [syncLoadingInline, setSyncLoadingInline] = useState(false);
  const [selectedBoxes, setSelectedBoxes] = useState([]);
  const [bulkDeleteLoading, setBulkDeleteLoading] = useState(false);

  // Confirm dialog state
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    title: "",
    content: "",
    onConfirm: null,
  });

  // Auto-refresh state
  const [autoRefreshPrcStatus, setAutoRefreshPrcStatus] = useState(false);
  const [autoRefreshSyncStatus, setAutoRefreshSyncStatus] = useState(false);
  const [prcStatusInterval, setPrcStatusInterval] = useState(null);
  const [syncStatusInterval, setSyncStatusInterval] = useState(null);

  // Helper to open confirm dialog
  const askConfirm = (title, content, onConfirm) => {
    setConfirmDialog({ open: true, title, content, onConfirm });
  };
  const handleCloseConfirm = () =>
    setConfirmDialog({ ...confirmDialog, open: false });
  const handleDoConfirm = () => {
    if (confirmDialog.onConfirm) confirmDialog.onConfirm();
    handleCloseConfirm();
  };

  // Wrap actions with confirm dialog
  const handleApplyChangesWithConfirm = (box) => {
    askConfirm(
      "Apply Changes",
      `Are you sure you want to apply changes to box ${box.box}?`,
      () => handleApplyChanges(box)
    );
  };
  const handleDeleteBoxWithConfirm = (box) => {
    askConfirm(
      "Delete Box",
      `Are you sure you want to delete box ${box.box}?`,
      () => handleDeleteBox(box)
    );
  };
  const handleReleaseDomainWithConfirm = () => {
    askConfirm(
      "Release Domain",
      "Are you sure you want to release the current domain?",
      handleReleaseDomain
    );
  };
  const handleResetPrcConfigWithConfirm = () => {
    askConfirm(
      "Reset PRC Config",
      "Are you sure you want to reset the PRC config?",
      handleResetPrcConfig
    );
  };
  const handleSaveOrderWithConfirm = () => {
    askConfirm(
      "Save Order",
      "Are you sure you want to save the new box order? This will delete and re-add all PRC boxes.",
      handleSaveOrder
    );
  };

  useEffect(() => {
    document.body.style.backgroundColor = grey[300];
  }, []);

  const fetchPrcData = async () => {
    let source = axios.CancelToken.source();
    try {
      setProgress(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "/slimsprc/boxes",
        { cancelToken: source.token, withCredentials: true }
      );
      setSlimsPrcData(response.data);
      setLoaded(true);
      setProgress(false);
    } catch (error) {
      console.error("Error fetching Slims PRC data:", error);
      if (axios.isCancel(error)) {
        console.info("Last Request Was Cancelled");
      } else {
        if (error.response.status === 401) {
          window.location.href = "/";
        }
      }
    }
  };

  useEffect(() => {
    fetchPrcData();
  }, []);

  const fetchPrcStatus = async () => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_URL + "/slimsprc/status",
        { withCredentials: true }
      );
      setPrcStatus(res.data);
    } catch (e) {
      if (
        e.response &&
        e.response.status === 404 &&
        e.response.data &&
        e.response.data.error
      ) {
        setPrcStatus(null);
      } else {
        setPrcStatus(null);
      }
    }
  };

  useEffect(() => {
    fetchPrcStatus();
  }, []);

  useEffect(() => {
    if (slimsPrcData.boxes) {
      setBoxOrder(slimsPrcData.boxes.map((b) => b.box));
    }
  }, [slimsPrcData.boxes]);

  const fetchSyncStatus = async ({ silent = false } = {}) => {
    if (!silent) setSyncLoading(true); // Show full loading indicator
    if (!silent) setSyncLoadingInline(true); // Show loading indicator for sync status
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_URL + "/slimsprc/next-subport/sync/all",
        { withCredentials: true }
      );
      setSyncStatus(res.data);
    } catch (e) {
      if (
        e.response &&
        e.response.status === 400 &&
        e.response.data &&
        e.response.data.error === "No boxes configured"
      ) {
        setSyncStatus({ error: "No boxes configured" });
      } else {
        setSyncStatus(null);
      }
    }
    if (!silent) setSyncLoading(false); // Hide full loading indicator after fetching
    if (!silent) setSyncLoadingInline(false);
  };

  useEffect(() => {
    fetchSyncStatus();
  }, []);

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedSubPort(null);
    setSelectedBox(null);
    // Do not reset checkedPorts here to preserve selection
  };

  const handleTogglePort = (port) => {
    setCheckedPorts((prev) => {
      const newPorts = prev.includes(port)
        ? prev.filter((p) => p !== port)
        : [...prev, port];
      // Update pending changes immediately
      if (selectedBox && selectedSubPort) {
        const key = `${selectedBox.box}_${selectedSubPort.subPort}`;
        const orig = originalPorts[key] || [];
        // Compare sorted arrays
        const changed =
          newPorts
            .slice()
            .sort((a, b) => a - b)
            .join(",") !==
          orig
            .slice()
            .sort((a, b) => a - b)
            .join(",");
        setPendingPortChanges((prevChanges) => {
          if (changed) {
            return {
              ...prevChanges,
              [key]: {
                box: selectedBox,
                subPort: selectedSubPort.subPort,
                ports: newPorts,
              },
            };
          } else {
            const updated = { ...prevChanges };
            delete updated[key];
            return updated;
          }
        });
      }
      return newPorts;
    });
  };

  const handleSelectAll = () => {
    const newPorts =
      selectAllButtonText === "Select All"
        ? Array.from({ length: 64 }, (_, i) => i + 1)
        : [];
    setCheckedPorts(newPorts);
    setSelectAllButtonText(
      newPorts.length === 64 ? "Remove All" : "Select All"
    );
    // Update pending changes immediately
    if (selectedBox && selectedSubPort) {
      const key = `${selectedBox.box}_${selectedSubPort.subPort}`;
      const orig = originalPorts[key] || [];
      const changed =
        newPorts
          .slice()
          .sort((a, b) => a - b)
          .join(",") !==
        orig
          .slice()
          .sort((a, b) => a - b)
          .join(",");
      setPendingPortChanges((prevChanges) => {
        if (changed) {
          return {
            ...prevChanges,
            [key]: {
              box: selectedBox,
              subPort: selectedSubPort.subPort,
              ports: newPorts,
            },
          };
        } else {
          const updated = { ...prevChanges };
          delete updated[key];
          return updated;
        }
      });
    }
  };

  const getSubPortLimitKey = (box, subPort) => `${box.box}_${subPort.subPort}`;

  const getPendingSubPortLimits = (box, subPort) => {
    const key = getSubPortLimitKey(box, subPort);
    return (
      pendingSubPortLimitChanges[key] || {
        globalLimit: subPort.globalLimit || "",
        fullDayLimit: subPort.fullDayLimit || "",
      }
    );
  };

  const hasSubPortLimitChange = (box, subPort) => {
    const key = getSubPortLimitKey(box, subPort);
    const pending = pendingSubPortLimitChanges[key];
    if (!pending) return false;
    return (
      String(pending.globalLimit || "") !== String(subPort.globalLimit || "") ||
      String(pending.fullDayLimit || "") !== String(subPort.fullDayLimit || "")
    );
  };

  const handleSubPortLimitChange = (box, subPort, field, value) => {
    const key = getSubPortLimitKey(box, subPort);
    const nextValue = value === "" ? "" : value.replace(/[^\d]/g, "");
    setPendingSubPortLimitChanges((prev) => {
      const current = prev[key] || {
        globalLimit: subPort.globalLimit || "",
        fullDayLimit: subPort.fullDayLimit || "",
      };
      const next = { ...current, [field]: nextValue };
      const updated = { ...prev };
      if (
        String(next.globalLimit || "") === String(subPort.globalLimit || "") &&
        String(next.fullDayLimit || "") === String(subPort.fullDayLimit || "")
      ) {
        delete updated[key];
      } else {
        updated[key] = next;
      }
      return updated;
    });
  };

  const handleStatus = (type, text = undefined) => {
    setShowBannerType(type);
    setStatus(true);
    setStatusText(
      text || (type === "success" ? "Successfully Updated!" : "Error Occurred!")
    );
    setTimeout(() => {
      setStatus(false);
      setStatusText("");
    }, 5000);
  };

  const handleSbluUpdate = async (box, newSblu, newSbluTriggerIn) => {
    try {
      await axios.patch(
        process.env.REACT_APP_API_URL + `/slimsprc/${box.box}/sblu`,
        {
          sblu: newSblu,
          sbluTriggerIn: newSbluTriggerIn,
        },
        { withCredentials: true }
      );
      setSlimsPrcData((prev) => ({
        ...prev,
        boxes: prev.boxes.map((b) =>
          b._id === box._id
            ? { ...b, sblu: newSblu, sbluTriggerIn: newSbluTriggerIn }
            : b
        ),
      }));
      let updatedFields = [];
      if (box.sblu !== newSblu) updatedFields.push("SBLU");
      if (box.sbluTriggerIn !== newSbluTriggerIn)
        updatedFields.push("SBLU Trigger In");
      handleStatus("success", `Updated: ${updatedFields.join(", ")}`);
    } catch (e) {
      handleStatus("error", "Failed to update SBLU");
    }
  };

  const handleSbluToggle = (box) => {
    // Prevent activating SBLU if only one subport
    if (!box.sblu && box.subPortRouting && box.subPortRouting.length === 1) {
      handleStatus("error", "SBLU cannot be activated on single subport box");
      return;
    }
    const newSblu = !box.sblu;
    const newSbluTriggerIn =
      typeof sbluTriggerValues[box._id] !== "undefined"
        ? Number(sbluTriggerValues[box._id])
        : box.sbluTriggerIn;
    handleSbluUpdate(box, newSblu, newSbluTriggerIn);
  };

  const handleSbluTriggerChange = (boxId, value) => {
    setSbluTriggerValues((prev) => ({ ...prev, [boxId]: value }));
  };

  const handleSbluTriggerBlur = (box) => {
    const newValue =
      typeof sbluTriggerValues[box._id] !== "undefined"
        ? Number(sbluTriggerValues[box._id])
        : box.sbluTriggerIn;
    // Prevent API call if not a positive integer
    if (!isPositiveInteger(newValue)) {
      handleStatus("error", "SBLU Trigger In must be a positive integer");
      // Optionally reset to previous valid value:
      setSbluTriggerValues((prev) => ({
        ...prev,
        [box._id]: box.sbluTriggerIn,
      }));
      return;
    }
    handleSbluUpdate(box, box.sblu, newValue);
  };

  const handleApplyChanges = async (box) => {
    setApplyLoading(true);
    // Validation: Ensure at least one port is selected for each subport
    const boxSubPorts = box.subPortRouting || [];
    for (const sub of boxSubPorts) {
      const key = `${box.box}_${sub.subPort}`;
      const selectedPorts =
        pendingPortChanges[key]?.ports ||
        (sub.portStats ? sub.portStats.map((p) => parseInt(p.port)) : []);
      if (!selectedPorts || selectedPorts.length === 0) {
        handleStatus(
          "error",
          `At least one port must be selected for SubPort ${sub.subPort} in box ${box.box}.`
        );
        setApplyLoading(false);
        return;
      }
    }
    const changes = Object.values(pendingPortChanges).filter(
      (change) => change.box.box === box.box
    );
    const limitChanges = Object.entries(pendingSubPortLimitChanges)
      .filter(([key]) => key.startsWith(`${box.box}_`))
      .map(([key, limits]) => ({
        key,
        subPort: key.split("_")[1],
        limits,
      }));
    try {
      for (const change of limitChanges) {
        if (
          change.limits.globalLimit &&
          !isPositiveInteger(change.limits.globalLimit)
        ) {
          throw new Error("SubPort Global Limit Override must be positive.");
        }
        if (
          change.limits.fullDayLimit &&
          !isPositiveInteger(change.limits.fullDayLimit)
        ) {
          throw new Error("SubPort Full Day Limit Override must be positive.");
        }
      }
      for (const change of changes) {
        await axios.put(
          process.env.REACT_APP_API_URL +
            `/slimsprc/${box.box}/subports/${change.subPort}/ports`,
          {
            ports: change.ports.map(String),
            ...(pendingSubPortLimitChanges[
              `${box.box}_${change.subPort}`
            ] || {}),
          },
          { withCredentials: true }
        );
      }
      for (const change of limitChanges) {
        if (changes.some((portChange) => portChange.subPort === change.subPort))
          continue;
        const sub = boxSubPorts.find((sp) => sp.subPort === change.subPort);
        await axios.put(
          process.env.REACT_APP_API_URL +
            `/slimsprc/${box.box}/subports/${change.subPort}/ports`,
          {
            ports: (sub.portStats || []).map((port) => String(port.port)),
            ...change.limits,
          },
          { withCredentials: true }
        );
      }
      setPendingPortChanges((prev) => {
        const updated = { ...prev };
        for (const change of changes) {
          delete updated[`${box.box}_${change.subPort}`];
        }
        return updated;
      });
      setPendingSubPortLimitChanges((prev) => {
        const updated = { ...prev };
        for (const change of limitChanges) {
          delete updated[change.key];
        }
        return updated;
      });
      handleStatus("success", "PRC subport settings updated successfully");
      await fetchPrcData(); // Fetch latest data after apply
      await fetchPrcStatus();
      await fetchSyncStatus({ silent: true });
    } catch (e) {
      handleStatus("error", e.message || "Failed to update PRC subport settings");
    }
    setApplyLoading(false);
  };

  const handleDeleteBox = async (box) => {
    try {
      await axios.delete(
        process.env.REACT_APP_API_URL + `/slimsprc/${box.box}`,
        { withCredentials: true }
      );
      setSlimsPrcData((prev) => ({
        ...prev,
        boxes: prev.boxes.filter((b) => b._id !== box._id),
      }));
      await fetchPrcStatus();
      await fetchSyncStatus();
      handleStatus("success", "Box deleted successfully");
    } catch (e) {
      handleStatus("error", "Failed to delete box");
    }
  };

  const openAddDialog = async () => {
    setAddDialogOpen(true);
    setAddError("");
    setNewBox("");
    setNewSubPorts([]);
    setNewPorts({});
    setNewSubPortLimits({});
    setNewSbluTriggerIn(3);
    setNewGlobalLimit(1);
    setNewFullDayLimit(150);
    // Fetch available boxes
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_URL + "/gateway/simboxes-unified",
        { withCredentials: true }
      );
      const allBoxes = res.data.SimBoxesUnifiedSet || [];
      // Filter out boxes already in PRC
      const existingBoxes = (slimsPrcData.boxes || []).map((b) => b.box);
      setAvailableBoxes(allBoxes.filter((b) => !existingBoxes.includes(b)));
    } catch (e) {
      setAvailableBoxes([]);
    }
  };

  const closeAddDialog = () => {
    setAddDialogOpen(false);
  };

  // Validation helpers
  const isPositiveInteger = (value) => {
    const n = Number(value);
    return Number.isInteger(n) && n > 0;
  };

  const handleAddBox = async () => {
    if (!newBox || newSubPorts.length === 0) {
      setAddError("Box and at least one subport are required.");
      return;
    }
    if (!isPositiveInteger(newGlobalLimit)) {
      setAddError("Global Limit must be a positive integer.");
      return;
    }
    if (!isPositiveInteger(newFullDayLimit)) {
      setAddError("Full Day Limit must be a positive integer.");
      return;
    }
    if (
      (typeof newSblu === "undefined" ? newSubPorts.length > 1 : newSblu) &&
      !isPositiveInteger(newSbluTriggerIn)
    ) {
      setAddError(
        "SBLU Trigger In must be a positive integer when SBLU is Active."
      );
      return;
    }
    for (const subPort of newSubPorts) {
      const limits = newSubPortLimits[subPort] || {};
      if (limits.globalLimit && !isPositiveInteger(limits.globalLimit)) {
        setAddError(
          `SubPort ${subPort} Global Limit Override must be positive.`
        );
        return;
      }
      if (limits.fullDayLimit && !isPositiveInteger(limits.fullDayLimit)) {
        setAddError(
          `SubPort ${subPort} Full Day Limit Override must be positive.`
        );
        return;
      }
    }
    // Build subPortRouting
    const subPortRouting = newSubPorts.map((subPort) => {
      const limits = newSubPortLimits[subPort] || {};
      return {
        subPort: subPort,
        ...(limits.globalLimit
          ? { globalLimit: Number(limits.globalLimit) }
          : {}),
        ...(limits.fullDayLimit
          ? { fullDayLimit: Number(limits.fullDayLimit) }
          : {}),
        portStats: (
          newPorts[subPort] ||
          Array.from({ length: 64 }, (_, i) => (i + 1).toString())
        ).map((p) => ({ port: p, count: 0 })),
      };
    });
    const payload = {
      box: newBox,
      sblu:
        newSubPorts.length === 1
          ? false
          : typeof newSblu === "undefined"
          ? newSubPorts.length > 1
            ? true
            : false
          : newSblu,
      sbluTriggerIn: newSbluTriggerIn,
      globalLimit: newGlobalLimit,
      fullDayLimit: newFullDayLimit,
      subPortRouting,
    };
    try {
      await axios.post(process.env.REACT_APP_API_URL + "/slimsprc", payload, {
        withCredentials: true,
      });
      setAddDialogOpen(false);
      await fetchPrcData();
      await fetchPrcStatus();
      await fetchSyncStatus();
      handleStatus("success", "Box added successfully");
    } catch (e) {
      setAddError("Failed to add box");
    }
  };

  const handleReleaseDomain = async () => {
    try {
      await axios.post(
        process.env.REACT_APP_API_URL + "/slimsprc/releaseCurrentDomain",
        {},
        { withCredentials: true }
      );
      setActionStatusType("success");
      setActionStatus("Domain released successfully");
      if (actionStatusTimeout) clearTimeout(actionStatusTimeout);
      setActionStatusTimeout(setTimeout(() => setActionStatus(""), 4000));
      fetchPrcStatus(); // refetch PRC status after action
    } catch (e) {
      setActionStatusType("error");
      setActionStatus("Failed to release domain");
      if (actionStatusTimeout) clearTimeout(actionStatusTimeout);
      setActionStatusTimeout(setTimeout(() => setActionStatus(""), 4000));
    }
  };

  const handleResetPrcConfig = async () => {
    try {
      await axios.delete(
        process.env.REACT_APP_API_URL + "/slimsprc/prc/config",
        { withCredentials: true }
      );
      setActionStatusType("success");
      setActionStatus("PRC Config reset successfully");
      if (actionStatusTimeout) clearTimeout(actionStatusTimeout);
      setActionStatusTimeout(setTimeout(() => setActionStatus(""), 4000));
      fetchPrcStatus(); // refetch PRC status after action
    } catch (e) {
      setActionStatusType("error");
      setActionStatus("Failed to reset PRC Config");
      if (actionStatusTimeout) clearTimeout(actionStatusTimeout);
      setActionStatusTimeout(setTimeout(() => setActionStatus(""), 4000));
    }
  };

  const moveBox = (idx, dir) => {
    setBoxOrder((prev) => {
      const arr = [...prev];
      const swapIdx = dir === "up" ? idx - 1 : idx + 1;
      if (swapIdx < 0 || swapIdx >= arr.length) return arr;
      [arr[idx], arr[swapIdx]] = [arr[swapIdx], arr[idx]];
      return arr;
    });
  };

  const handleSaveOrder = () => {
    setShowReorderDialog(true);
  };

  const handleConfirmReorder = async () => {
    setReorderLoading(true);
    try {
      // Get full box data in new order
      const boxMap = {};
      (slimsPrcData.boxes || []).forEach((b) => {
        boxMap[b.box] = b;
      });
      // Delete all boxes
      for (const box of slimsPrcData.boxes) {
        await axios.delete(
          process.env.REACT_APP_API_URL + `/slimsprc/${box.box}`,
          { withCredentials: true }
        );
      }
      // Re-add in new order
      for (const boxName of boxOrder) {
        const b = boxMap[boxName];
        const payload = {
          box: b.box,
          sblu: b.sblu,
          sbluTriggerIn: b.sbluTriggerIn,
          globalLimit: b.globalLimit,
          fullDayLimit: b.fullDayLimit,
          subPortRouting: b.subPortRouting,
        };
        await axios.post(process.env.REACT_APP_API_URL + "/slimsprc", payload, {
          withCredentials: true,
        });
      }
      setShowReorderDialog(false);
      await fetchPrcData();
      handleStatus("success", "Box order updated!");
    } catch (e) {
      handleStatus("error", "Failed to reorder boxes");
    }
    setReorderLoading(false);
  };

  // Sync all out-of-sync boxes
  const handleSyncNow = async () => {
    if (!syncStatus || !syncStatus.boxes) return;
    setSyncingNow(true);
    try {
      // Find all out-of-sync boxes
      const outOfSyncBoxes = syncStatus.boxes.filter((b) => !b.inSync);
      // Send sync request for each out-of-sync box (parallel)
      await Promise.all(
        outOfSyncBoxes.map((b) =>
          axios.post(
            process.env.REACT_APP_API_URL + `/slimsprc/${b.box}/sblu/sync`,
            {deviceSubPort: b.deviceSubPort, expectedSubPort: b.expectedSubPort},
            { withCredentials: true }
          )
        )
      );
      // Refresh sync status after all syncs
      await fetchSyncStatus();
    } catch (e) {
      // Optionally handle error
    }
    setSyncingNow(false);
  };

  // Bulk delete handler
  const doBulkDelete = async () => {
    if (selectedBoxes.length === 0) return;
    setBulkDeleteLoading(true);
    try {
      await axios.post(
        process.env.REACT_APP_API_URL + "/slimsprc/bulk-delete/box",
        { boxes: selectedBoxes },
        { withCredentials: true }
      );
      setSelectedBoxes([]);
      await fetchPrcData();
      await fetchPrcStatus();
      await fetchSyncStatus();
      handleStatus("success", "Boxes deleted successfully");
    } catch (e) {
      handleStatus("error", "Bulk delete failed");
    }
    setBulkDeleteLoading(false);
  };

  // Show confirm dialog before bulk delete
  const handleBulkDelete = () => {
    askConfirm(
      "Bulk Delete",
      `Are you sure you want to delete ${selectedBoxes.length} selected box(es)?`,
      doBulkDelete
    );
  };

  // Checkbox helpers
  const handleSelectBox = (boxName) => {
    setSelectedBoxes((prev) =>
      prev.includes(boxName)
        ? prev.filter((b) => b !== boxName)
        : [...prev, boxName]
    );
  };
  const handleSelectAllBoxes = () => {
    if (!slimsPrcData.boxes) return;
    if (selectedBoxes.length === slimsPrcData.boxes.length) {
      setSelectedBoxes([]);
    } else {
      setSelectedBoxes(slimsPrcData.boxes.map((b) => b.box));
    }
  };

  // Auto-refresh handlers
  const toggleAutoRefreshPrcStatus = () => {
    setAutoRefreshPrcStatus((prev) => {
      if (!prev) {
        if (!prcStatusInterval) {
          const interval = setInterval(() => {
            fetchPrcStatus();
          }, 3000); // Refresh every 5 seconds
          setPrcStatusInterval(interval);
        }
      } else {
        if (prcStatusInterval) {
          clearInterval(prcStatusInterval);
          setPrcStatusInterval(null);
        }
      }
      return !prev;
    });
  };

  const toggleAutoRefreshSyncStatus = () => {
    setAutoRefreshSyncStatus((prev) => {
      if (!prev) {
        if (!syncStatusInterval) {
          const interval = setInterval(() => {
            fetchSyncStatus();
          }, 8000); // Refresh every 10 seconds
          setSyncStatusInterval(interval);
        }
      } else {
        if (syncStatusInterval) {
          clearInterval(syncStatusInterval);
          setSyncStatusInterval(null);
        }
      }
      return !prev;
    });
  };

  useEffect(() => {
    // Cleanup intervals on component unmount
    return () => {
      if (prcStatusInterval) clearInterval(prcStatusInterval);
      if (syncStatusInterval) clearInterval(syncStatusInterval);
    };
  }, [prcStatusInterval, syncStatusInterval]);

  useEffect(() => {
    let prcStatusInterval = null;
    if (autoRefreshPrcStatus) {
      prcStatusInterval = setInterval(() => {
        fetchPrcStatus();
      }, 5000); // Refresh every 5 seconds
    }
    return () => {
      if (prcStatusInterval) clearInterval(prcStatusInterval);
    };
  }, [autoRefreshPrcStatus]);

  useEffect(() => {
    let syncStatusInterval = null;
    if (autoRefreshSyncStatus) {
      syncStatusInterval = setInterval(() => {
        fetchSyncStatus();
      }, 10000); // Refresh every 10 seconds
    }
    return () => {
      if (syncStatusInterval) clearInterval(syncStatusInterval);
    };
  }, [autoRefreshSyncStatus]);

  const [isSyncCardMaximized, setIsSyncCardMaximized] = useState(false); // State to track card maximization

  const toggleSyncCardMaximize = () => {
    setIsSyncCardMaximized((prev) => !prev);
  };

  if (loaded) {
    // Determine if box order has changed
    const originalOrder = (slimsPrcData.boxes || []).map((b) => b.box);
    const isOrderChanged =
      boxOrder.length === originalOrder.length &&
      boxOrder.some((box, idx) => box !== originalOrder[idx]);
    const mainContent =
      !slimsPrcData.boxes || slimsPrcData.boxes.length === 0 ? (
        <>
          <Alert severity="info" style={{ margin: 24 }}>
            No SLIMS-PRC Config Found
          </Alert>
        </>
      ) : (
        <>
          {/* Bulk Delete Button & Save Order Button */}
          <Box display="flex" justifyContent="space-between" mb={1}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveOrderWithConfirm}
              disabled={!isOrderChanged}
              style={{ minWidth: 140 }}
              startIcon={<SaveAltIcon />}
            >
              Save Order
            </Button>
            <Button
              variant="contained"
              color="secondary"
              disabled={selectedBoxes.length === 0 || bulkDeleteLoading}
              onClick={handleBulkDelete}
              style={{ minWidth: 140 }}
              startIcon={<DeleteSweepIcon />}
            >
              {bulkDeleteLoading
                ? "Deleting..."
                : `Bulk Delete (${selectedBoxes.length})`}
            </Button>
          </Box>
          {progress === false && status && (
            <Alert severity={showBannerType}>{statusText}</Alert>
          )}
          <TableContainer
            component={Paper}
            elevation={20}
            style={{ margin: "20px" }}
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableHeaderCell padding="checkbox">
                    <Checkbox
                      // color red
                      style={{ color: "#fff" }}
                      indeterminate={
                        selectedBoxes.length > 0 &&
                        selectedBoxes.length < (slimsPrcData.boxes || []).length
                      }
                      checked={
                        slimsPrcData.boxes &&
                        selectedBoxes.length === slimsPrcData.boxes.length &&
                        selectedBoxes.length > 0
                      }
                      onChange={handleSelectAllBoxes}
                      color="primary"
                    />
                  </TableHeaderCell>
                  <TableHeaderCell style={{ minWidth: 285 }}>
                    Apply / Delete
                  </TableHeaderCell>
                  <TableHeaderCell>Box</TableHeaderCell>
                  <TableHeaderCell>SBLU</TableHeaderCell>
                  <TableHeaderCell>SBLU Trigger In</TableHeaderCell>
                  <TableHeaderCell>Global Limit</TableHeaderCell>
                  <TableHeaderCell>Full Day Limit</TableHeaderCell>
                  <TableHeaderCell>SubPorts / Ports</TableHeaderCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {boxOrder.map((boxName, idx) => {
                  const box = (slimsPrcData.boxes || []).find(
                    (b) => b.box === boxName
                  );
                  if (!box) return null;
                  const boxHasPending =
                    Object.keys(pendingPortChanges).some((key) =>
                      key.startsWith(`${box.box}_`)
                    ) ||
                    Object.keys(pendingSubPortLimitChanges).some((key) =>
                      key.startsWith(`${box.box}_`)
                    );
                  return (
                    <TableRow key={box._id} hover>
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedBoxes.includes(box.box)}
                          onChange={() => handleSelectBox(box.box)}
                          color="primary"
                        />
                      </TableCell>
                      <TableCell style={{ minWidth: 285, whiteSpace: "nowrap" }}>
                        <Box display="flex" alignItems="center" flexWrap="nowrap">
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            disabled={!boxHasPending || applyLoading}
                            onClick={() => handleApplyChangesWithConfirm(box)}
                            style={{ marginRight: 4, minWidth: 100 }}
                            startIcon={<SyncOutlinedIcon />}
                          >
                            Apply Changes
                          </Button>
                          <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            startIcon={<DeleteIcon />}
                            onClick={() => handleDeleteBoxWithConfirm(box)}
                            disabled={applyLoading}
                            style={{ minWidth: 100 }}
                          >
                            Delete Box
                          </Button>
                          <Button
                            size="small"
                            onClick={() => moveBox(idx, "up")}
                            disabled={idx === 0}
                            style={{ minWidth: 32, marginLeft: 8 }}
                          >
                            <ArrowUpwardIcon fontSize="small" />
                          </Button>
                          <Button
                            size="small"
                            onClick={() => moveBox(idx, "down")}
                            disabled={idx === boxOrder.length - 1}
                            style={{ minWidth: 32 }}
                          >
                            <ArrowDownwardIcon fontSize="small" />
                          </Button>
                        </Box>
                      </TableCell>
                      <TableCell>{box.box}</TableCell>
                      <TableCell>
                        <Chip
                          label={
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                minWidth: 68, // Ensures both "Active" and "Inactive" take same width
                                justifyContent: "center",
                                letterSpacing: 1,
                              }}
                            >
                              {box.sblu ? (
                                <>
                                  <CheckCircleIcon
                                    style={{ fontSize: 15, marginRight: 3 }}
                                  />
                                  <span
                                    style={{
                                      width: 50,
                                      display: "inline-block",
                                      textAlign: "left",
                                    }}
                                  >
                                    Active
                                  </span>
                                </>
                              ) : (
                                <>
                                  <ErrorOutlineIcon
                                    style={{ fontSize: 15, marginRight: 3 }}
                                  />
                                  <span
                                    style={{
                                      width: 50,
                                      display: "inline-block",
                                      textAlign: "left",
                                    }}
                                  >
                                    Inactive
                                  </span>
                                </>
                              )}
                            </span>
                          }
                          color={box.sblu ? undefined : undefined}
                          size="small"
                          clickable
                          onClick={() =>
                            askConfirm(
                              box.sblu ? "Deactivate SBLU" : "Activate SBLU",
                              `Are you sure you want to ${
                                box.sblu ? "deactivate" : "activate"
                              } SBLU for box ${box.box}?`,
                              () => handleSbluToggle(box)
                            )
                          }
                          style={
                            box.sblu
                              ? {
                                  backgroundColor: "#4caf50",
                                  color: "white",
                                  fontWeight: 600,
                                  fontSize: 13,
                                  minWidth: 90,
                                  height: 28,
                                  padding: "0 8px",
                                  justifyContent: "flex-start",
                                }
                              : {
                                  backgroundColor: "#f44336",
                                  color: "white",
                                  fontWeight: 600,
                                  fontSize: 13,
                                  minWidth: 90,
                                  height: 28,
                                  padding: "0 8px",
                                  justifyContent: "flex-start",
                                }
                          }
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          type="number"
                          value={
                            typeof sbluTriggerValues[box._id] !== "undefined"
                              ? sbluTriggerValues[box._id]
                              : box.sbluTriggerIn
                          }
                          onChange={(e) =>
                            handleSbluTriggerChange(box._id, e.target.value)
                          }
                          onBlur={() => handleSbluTriggerBlur(box)}
                          size="small"
                          variant="standard"
                          style={{ width: 100 }}
                          inputProps={{
                            min: 1,
                            step: 1,
                            style: { textAlign: "center" }, // Center the number
                          }}
                          disabled={!box.sblu}
                          error={
                            box.sblu &&
                            !isPositiveInteger(
                              typeof sbluTriggerValues[box._id] !== "undefined"
                                ? sbluTriggerValues[box._id]
                                : box.sbluTriggerIn
                            )
                          }
                          helperText={
                            box.sblu &&
                            !isPositiveInteger(
                              typeof sbluTriggerValues[box._id] !== "undefined"
                                ? sbluTriggerValues[box._id]
                                : box.sbluTriggerIn
                            )
                              ? "Enter a positive integer"
                              : ""
                          }
                        />
                      </TableCell>
                      <TableCell>{box.globalLimit}</TableCell>
                      <TableCell>{box.fullDayLimit}</TableCell>
                      <TableCell>
                        <Box
                          display="flex"
                          flexDirection="row"
                          flexWrap="wrap"
                          alignItems="center"
                          gridGap={12}
                        >
                          {box.subPortRouting &&
                            box.subPortRouting.map((sub, idx) => {
                              const key = `${box.box}_${sub.subPort}`;
                              const currentPorts =
                                pendingPortChanges[key]?.ports ||
                                (sub.portStats
                                  ? sub.portStats.map((p) => parseInt(p.port))
                                  : []);
                              const hasPendingLimit = hasSubPortLimitChange(
                                box,
                                sub
                              );
                              return (
                                <Button
                                  key={idx}
                                  component={Paper}
                                  elevation={5}
                                  color="primary"
                                  variant="outlined"
                                  style={{
                                    marginRight: 8,
                                    marginBottom: 8,
                                    minWidth: 100,
                                    textTransform: "none",
                                  }}
                                  onClick={(e) => {
                                    setAnchorEl(e.currentTarget);
                                    setSelectedBox(box);
                                    setSelectedSubPort(sub);
                                    const key = `${box.box}_${sub.subPort}`;
                                    // Use pending changes if available, else original
                                    const portsToShow =
                                      pendingPortChanges[key]?.ports ||
                                      (sub && sub.portStats
                                        ? sub.portStats.map((p) =>
                                            parseInt(p.port)
                                          )
                                        : []);
                                    setCheckedPorts(portsToShow);
                                    setOriginalPorts((prev) => ({
                                      ...prev,
                                      [key]:
                                        sub && sub.portStats
                                          ? sub.portStats.map((p) =>
                                              parseInt(p.port)
                                            )
                                          : [],
                                    }));
                                    setSelectAllButtonText(
                                      portsToShow.length === 64
                                        ? "Remove All"
                                        : "Select All"
                                    );
                                  }}
                                >
                                  <Box textAlign="left">
                                    <Box>{`SP ${sub.subPort} | ${currentPorts.length}`}</Box>
                                    <Box
                                      fontSize={11}
                                      fontWeight={600}
                                      style={{
                                        color: hasPendingLimit
                                          ? "#f50057"
                                          : "#63758f",
                                      }}
                                    >
                                      {`GL ${
                                        getPendingSubPortLimits(box, sub)
                                          .globalLimit || "-"
                                      } / FD ${
                                        getPendingSubPortLimits(box, sub)
                                          .fullDayLimit || "-"
                                      }`}
                                    </Box>
                                  </Box>
                                </Button>
                              );
                            })}
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <Menu
            id="port-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={() => {
              handleMenuClose();
              // No need to update pendingPortChanges here, handled on toggle/selectAll
            }}
            PaperProps={{
              style: { maxHeight: 400, width: 180, overflow: "hidden" },
            }}
          >
            {selectedBox && selectedSubPort && (
              <Box
                px={2}
                pt={0.75}
                pb={0.5}
              >
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: 700, marginBottom: 4 }}
                >
                  {`SP-${selectedSubPort.subPort} Overrides`}
                </Typography>
                <Box display="flex" gridGap={8}>
                  <TextField
                    type="number"
                    label="Global"
                    value={
                      getPendingSubPortLimits(selectedBox, selectedSubPort)
                        .globalLimit
                    }
                    onChange={(e) =>
                      handleSubPortLimitChange(
                        selectedBox,
                        selectedSubPort,
                        "globalLimit",
                        e.target.value
                      )
                    }
                    placeholder={`${selectedBox.globalLimit}`}
                    margin="none"
                    style={{ width: 68 }}
                    inputProps={{ min: 1, step: 1 }}
                  />
                  <TextField
                    type="number"
                    label="Full Day"
                    value={
                      getPendingSubPortLimits(selectedBox, selectedSubPort)
                        .fullDayLimit
                    }
                    onChange={(e) =>
                      handleSubPortLimitChange(
                        selectedBox,
                        selectedSubPort,
                        "fullDayLimit",
                        e.target.value
                      )
                    }
                    placeholder={`${selectedBox.fullDayLimit}`}
                    margin="none"
                    style={{ width: 78 }}
                    inputProps={{ min: 1, step: 1 }}
                  />
                </Box>
              </Box>
            )}
            <Divider />
            <MenuItem>
              <Button
                color="primary"
                variant="contained"
                onClick={handleSelectAll}
                fullWidth
              >
                {selectAllButtonText}
              </Button>
            </MenuItem>
            <Divider />
            <Box
              px={2}
              py={1}
              style={{
                maxHeight: 250,
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: 140,
              }}
            >
              <FormGroup>
                {[...Array(64)].map((_, i) => (
                  <FormControlLabel
                    key={i + 1}
                    value={i + 1}
                    control={
                      <Checkbox
                        checked={checkedPorts.includes(i + 1)}
                        onChange={() => handleTogglePort(i + 1)}
                        color="primary"
                      />
                    }
                    label={`Port - ${i + 1}`}
                  />
                ))}
              </FormGroup>
            </Box>
          </Menu>
        </>
      );
    return (
      <>
        <style>
          {`
            @keyframes prcNextSlotPulse {
              0%, 100% {
                transform: translateY(0) scale(1);
                box-shadow: 0 1px 4px rgba(13, 71, 161, 0.30);
              }
              50% {
                transform: translateY(-2px) scale(1.03);
                box-shadow: 0 6px 16px rgba(13, 71, 161, 0.45);
              }
            }
          `}
        </style>
        {progress && <ProgrssBar />}
        <Grid
          container
          spacing={2}
          style={{
            marginTop: isSyncCardMaximized ? 10 : 0, // Dynamic marginTop
            marginBottom: 8,
            justifyContent: "flex-end",
            alignItems: "stretch",
          }}
        >
          <Grid item xs={12} sm={6} md={4} lg={3} style={{ display: "flex" }}>
            <Card
              style={{
                background: "#f5faff",
                borderLeft: "4px solid #1976d2",
                width: "100%",
              }}
            >
              <CardContent
                style={{
                  padding: 12,
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={0.5}
                >
                  <Typography
                    variant="subtitle1"
                    style={{ fontWeight: 600, color: "#1976d2" }}
                  >
                    PRC Status
                  </Typography>
                  <Switch
                    size="small"
                    color="primary"
                    checked={autoRefreshPrcStatus}
                    onChange={toggleAutoRefreshPrcStatus}
                  />
                </Box>
                {prcStatus ? (
                  <>
                    <Typography variant="body2">
                      <b>Next Slot Index:</b> {prcStatus.nextSlotIndex}
                    </Typography>
                    <Typography variant="body2">
                      <b>Capacity Used:</b>{" "}
                      {typeof prcStatus.prcUsed === "number"
                        ? prcStatus.prcUsed
                        : 0}{" "}
                      /{" "}
                      {typeof prcStatus.prcCapacity === "number"
                        ? prcStatus.prcCapacity
                        : 0}
                    </Typography>
                    <Typography variant="body2">
                      <b>Current Domain:</b>{" "}
                      {prcStatus.currentDomain &&
                      prcStatus.currentDomain !== "null" &&
                      prcStatus.currentDomain !== "N/A"
                        ? prcStatus.currentDomain
                        : "Domain Released"}
                    </Typography>
                    <Typography variant="body2">
                      <b>Next Slot:</b> Box {prcStatus.nextSlot?.box}, SubPort{" "}
                      {prcStatus.nextSlot?.subPort}, Port{" "}
                      {prcStatus.nextSlot?.port}
                    </Typography>
                    <Typography variant="body2">
                      <b>CSB:</b>{" "}
                      {typeof prcStatus.csbTodayCount === "number"
                        ? prcStatus.csbTodayCount
                        : 0}, <b>ICR:</b>{" "}
                      {typeof prcStatus.icrTodayCount === "number"
                        ? prcStatus.icrTodayCount
                        : 0}, <b>DCL:</b>{" "}
                      {typeof prcStatus.dclTodayCount === "number"
                        ? prcStatus.dclTodayCount
                        : 0}
                    </Typography>
                  </>
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    PRCConfig not initialized
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={6} style={{ display: "flex" }}>
            <Card
              style={{
                background:
                  syncLoading && !syncLoadingInline
                    ? "#f5faff"
                    : syncStatus && syncStatus.error === "No boxes configured"
                    ? "#fff3e0"
                    : syncStatus &&
                      syncStatus.boxes &&
                      syncStatus.boxes.some((b) => !b.inSync)
                    ? "#ffebee"
                    : "#e8f5e9",
                borderLeft: syncLoading
                  ? "4px solid #1976d2"
                  : syncStatus && syncStatus.error === "No boxes configured"
                  ? "4px solid #ff9800"
                  : syncStatus &&
                    syncStatus.boxes &&
                    syncStatus.boxes.some((b) => !b.inSync)
                  ? "4px solid #f44336"
                  : "4px solid #4caf50",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                position: isSyncCardMaximized ? "fixed" : "relative",
                top: isSyncCardMaximized ? 0 : "unset",
                left: isSyncCardMaximized ? 0 : "unset",
                height: isSyncCardMaximized ? "100vh" : "auto",
                zIndex: isSyncCardMaximized ? 999 : "auto", // Reduced zIndex for maximized card
                overflow: isSyncCardMaximized ? "auto" : "hidden",
              }}
            >
              <CardContent
                style={{
                  padding: 12,
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  boxSizing: "border-box",
                }}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  mt={isSyncCardMaximized ? 8 : 0}
                >
                  <Typography
                    variant="subtitle1"
                    style={{
                      fontWeight: 600,
                      color: syncLoading
                        ? "#1976d2"
                        : syncStatus &&
                          syncStatus.error === "No boxes configured"
                        ? "#ff9800"
                        : syncStatus &&
                          syncStatus.boxes &&
                          syncStatus.boxes.some((b) => !b.inSync)
                        ? "#f44336"
                        : "#388e3c",
                      marginBottom: 4,
                    }}
                  >
                    {(() => {
                      if (
                        syncStatus &&
                        syncStatus.error === "No boxes configured"
                      ) {
                        return "PRC Box Sync Status (No Boxes Configured)";
                      }
                      if (syncStatus && syncStatus.boxes) {
                        const outOfSync = syncStatus.boxes.filter(
                          (b) => !b.inSync
                        );
                        if (outOfSync.length > 0) {
                          return `PRC Box Sync Status (${outOfSync.length} box${
                            outOfSync.length > 1 ? "es" : ""
                          } Out Of Sync)`;
                        } else {
                          return "PRC Box Sync Status (In Sync)";
                        }
                      }
                      return "PRC Box Sync Status";
                    })()}
                    &nbsp;
                    {syncLoadingInline && autoRefreshSyncStatus && (
                      <CircularProgress size={16} />
                    )}
                  </Typography>
                  <Box display="flex" alignItems="center">
                    <Switch
                      size="small"
                      color="primary"
                      checked={autoRefreshSyncStatus}
                      onChange={toggleAutoRefreshSyncStatus}
                      style={{ marginRight: 8 }}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      startIcon={<SyncOutlinedIcon />}
                      onClick={() =>
                        askConfirm(
                          "Sync Now",
                          "Are you sure you want to sync all out-of-sync boxes?",
                          handleSyncNow
                        )
                      }
                      disabled={
                        syncingNow ||
                        syncLoading ||
                        !(
                          syncStatus &&
                          syncStatus.boxes &&
                          syncStatus.boxes.length > 0 &&
                          syncStatus.boxes.some((b) => !b.inSync)
                        )
                      }
                      style={{
                        minWidth: 120,
                        backgroundColor: syncingNow ? "#bdbdbd" : undefined,
                        color: syncingNow ? "#fff" : undefined,
                      }}
                    >
                      {syncingNow ? "Syncing..." : "Sync Now (SBLU)"}
                    </Button>
                    <Button
                      size="small"
                      onClick={toggleSyncCardMaximize}
                      style={{ marginLeft: 8 }}
                    >
                      <FullscreenIcon />
                    </Button>
                  </Box>
                </Box>
                {isSyncCardMaximized && (
                  <Box
                    style={{
                      marginTop: 16,
                      marginBottom: 16,
                      padding: 16,
                      background: "#f5faff",
                      borderRadius: 8,
                      display: "flex",
                      flexDirection: "row",
                      gap: 16,
                    }}
                  >
                    {/* PRC Status Section */}
                    <Box flex={1}>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        mb={0.5}
                      >
                        <Typography
                          variant="h6"
                          style={{ fontWeight: 600, marginBottom: 2 }}
                        >
                          PRC Status
                        </Typography>
                        <Switch
                          size="small"
                          color="primary"
                          checked={autoRefreshPrcStatus}
                          onChange={toggleAutoRefreshPrcStatus}
                        />
                      </Box>
                      {prcStatus ? (
                        <>
                          <Typography variant="body2">
                            <b>Next Slot Index:</b> {prcStatus.nextSlotIndex}
                          </Typography>
                          <Typography variant="body2">
                            <b>Capacity Used:</b>{" "}
                            {typeof prcStatus.prcUsed === "number"
                              ? prcStatus.prcUsed
                              : 0}{" "}
                            /{" "}
                            {typeof prcStatus.prcCapacity === "number"
                              ? prcStatus.prcCapacity
                              : 0}
                          </Typography>
                          <Typography variant="body2">
                            <b>Current Domain:</b>{" "}
                            {prcStatus.currentDomain &&
                            prcStatus.currentDomain !== "null" &&
                            prcStatus.currentDomain !== "N/A"
                              ? prcStatus.currentDomain
                              : "Domain Released"}
                          </Typography>
                          <Typography variant="body2">
                            <b>Next Slot:</b> Box {prcStatus.nextSlot?.box},
                            SubPort {prcStatus.nextSlot?.subPort}, Port{" "}
                            {prcStatus.nextSlot?.port}
                          </Typography>
                          <Typography variant="body2">
                            <b>CSB:</b>{" "}
                            {typeof prcStatus.csbTodayCount === "number"
                              ? prcStatus.csbTodayCount
                              : 0}, <b>ICR:</b>{" "}
                            {typeof prcStatus.icrTodayCount === "number"
                              ? prcStatus.icrTodayCount
                              : 0}, <b>DCL:</b>{" "}
                            {typeof prcStatus.dclTodayCount === "number"
                              ? prcStatus.dclTodayCount
                              : 0}
                          </Typography>
                        </>
                      ) : (
                        <Typography variant="body2" color="textSecondary">
                          PRCConfig not initialized
                        </Typography>
                      )}
                    </Box>

                    {/* PRC Actions Section */}
                    <Box flex={1}>
                      <Typography
                        variant="h6"
                        style={{ fontWeight: 600, marginBottom: 8 }}
                      >
                        PRC Actions
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        style={{ marginBottom: 8 }}
                        onClick={handleReleaseDomainWithConfirm}
                        startIcon={<DomainDisabledIcon />}
                      >
                        Release Domain
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={handleResetPrcConfigWithConfirm}
                        startIcon={<RestoreIcon />}
                      >
                        Reset PRC Config
                      </Button>
                      {actionStatus && (
                        <Alert
                          severity={actionStatusType}
                          style={{ marginTop: 10 }}
                        >
                          {actionStatus}
                        </Alert>
                      )}
                    </Box>
                  </Box>
                )}
                {syncLoading && !autoRefreshSyncStatus ? (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    minHeight={60}
                  >
                    <CircularProgress size={32} />
                  </Box>
                ) : syncStatus && syncStatus.error === "No boxes configured" ? (
                  <Typography variant="body2" color="textSecondary">
                    Nothing to sync. No boxes configured.
                  </Typography>
                ) : syncStatus && syncStatus.boxes ? (
                  <Box
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 8,
                      maxHeight: isSyncCardMaximized
                        ? "calc(100vh - 200px)"
                        : 90,
                      overflowY: "auto",
                      marginBottom: 6,
                      marginTop: 2,
                      paddingTop: 8,
                      paddingLeft: 4,
                      paddingBottom: 4,
                    }}
                  >
                    {syncStatus.boxes.map((b) => {
                      const registration = b.registration || {};
                      const isAllRegistered = registration.isAllRegistered;
                      const unregisteredPorts = registration.ports || [];
                      const totalPorts = 64; // Assuming total ports are 64
                      const unregisteredCount = unregisteredPorts.length;
                      const greenRatio =
                        ((totalPorts - unregisteredCount) / totalPorts) * 100;
                      const yellowRatio =
                        (unregisteredCount / totalPorts) * 100;
                      const isNextSlotBox =
                        prcStatus?.nextSlot?.box &&
                        String(prcStatus.nextSlot.box) === String(b.box);
                      const shouldAnimateNextSlotBox =
                        isNextSlotBox && !addDialogOpen;

                      return (
                        <Box
                          key={b.box}
                          display="flex"
                          alignItems="center"
                          mb={0.5}
                          style={{
                            marginRight: 8,
                            width: 250,
                            minHeight: 32,
                            background: "rgba(0,0,0,0.01)",
                            borderRadius: 6,
                            padding: "2px 4px",
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                          }}
                        >
                          <Chip
                            size="medium"
                            icon={
                              b.inSync ? (
                                <CheckCircleIcon style={{ color: "#fff" }} />
                              ) : (
                                <ErrorOutlineIcon style={{ color: "#fff" }} />
                              )
                            }
                            label={`Box: ${b.box}`}
                            style={{
                              background: b.inSync
                                ? isAllRegistered
                                  ? "#4caf50"
                                  : `linear-gradient(to right, #4caf50 ${greenRatio}%, #ff9800 ${yellowRatio}%)`
                                : "#f44336",
                              color: "white",
                              fontWeight: 600,
                              marginRight: 4,
                              animation: shouldAnimateNextSlotBox
                                ? "prcNextSlotPulse 1.1s ease-in-out infinite"
                                : undefined,
                              transformOrigin: "center",
                              willChange: shouldAnimateNextSlotBox
                                ? "transform"
                                : undefined,
                            }}
                            onMouseEnter={(e) => {
                              if (
                                !isAllRegistered &&
                                unregisteredPorts.length > 0
                              ) {
                                const tooltip = document.createElement("div");
                                tooltip.style.position = "absolute";
                                tooltip.style.background = "#ff9800";
                                tooltip.style.color = "#fff";
                                tooltip.style.padding = "8px";
                                tooltip.style.borderRadius = "4px";
                                tooltip.style.boxShadow =
                                  "0 2px 4px rgba(0, 0, 0, 0.2)";
                                tooltip.style.zIndex = 1000;
                                tooltip.style.top = `${e.clientY + 10}px`;
                                tooltip.style.left = `${e.clientX + 10}px`;
                                tooltip.innerText = `Unregister Ports: ${unregisteredPorts.join(
                                  ", "
                                )}`;
                                tooltip.id = "tooltip";
                                document.body.appendChild(tooltip);
                              }
                            }}
                            onMouseLeave={() => {
                              const tooltip =
                                document.getElementById("tooltip");
                              if (tooltip) {
                                document.body.removeChild(tooltip);
                              }
                            }}
                          />
                          <Typography
                            variant="caption"
                            style={{
                              color: b.inSync ? "#388e3c" : "#b71c1c",
                              whiteSpace: "normal",
                              width: "100%",
                              wordBreak: "break-word",
                            }}
                          >
                            {b.inSync
                              ? `SubPort: ${b.deviceSubPort} (in sync)`
                              : `Expected: ${b.expectedSubPort}, Device: ${b.deviceSubPort}`}
                            {!isAllRegistered && b.inSync && (
                              <Typography
                                variant="caption"
                                style={{ color: "#d17b00", display: "block" }}
                              >
                                {`${unregisteredCount} Port${
                                  unregisteredCount > 1 ? "s" : ""
                                } Unregister`}
                              </Typography>
                            )}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    Unable to fetch sync status.
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} style={{ display: "flex" }}>
            <Card
              style={{
                background: "#fff8f5",
                borderLeft: "4px solid #ff9800",
                width: "100%",
              }}
            >
              <CardContent
                style={{
                  padding: 12,
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="subtitle1"
                  style={{ fontWeight: 600, color: "#ff9800", marginBottom: 4 }}
                >
                  PRC Actions
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  style={{ marginBottom: 8 }}
                  onClick={handleReleaseDomainWithConfirm}
                  startIcon={<DomainDisabledIcon />}
                >
                  Release Domain
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  onClick={handleResetPrcConfigWithConfirm}
                  startIcon={<RestoreIcon />}
                >
                  Reset PRC Config
                </Button>
                {actionStatus && (
                  <Alert severity={actionStatusType} style={{ marginTop: 10 }}>
                    {actionStatus}
                  </Alert>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        {mainContent}
        <Fab
          color="primary"
          aria-label="add"
          style={{ position: "fixed", bottom: 32, right: 32, zIndex: 9999 }}
          onClick={openAddDialog}
        >
          <AddIcon />
        </Fab>
        <Dialog
          open={addDialogOpen}
          onClose={closeAddDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Add New PRC Box</DialogTitle>
          <DialogContent>
            {addError && <Alert severity="error">{addError}</Alert>}
            <TextField
              select
              label="Box"
              value={newBox}
              onChange={(e) => setNewBox(e.target.value)}
              fullWidth
              margin="normal"
              SelectProps={{ native: true }}
              required
            >
              <option value=""></option>
              {availableBoxes.map((b) => (
                <option key={b} value={b}>
                  {b}
                </option>
              ))}
            </TextField>
            <Box display="flex" flexWrap="wrap" mb={2}>
              {[...Array(8)].map((_, i) => {
                const subPortNum = (i + 1).toString();
                const isSelected = newSubPorts.includes(subPortNum);
                return (
                  <Button
                    key={subPortNum}
                    variant={isSelected ? "contained" : "outlined"}
                    color={isSelected ? "primary" : "default"}
                    disabled={isSelected}
                    style={{ marginRight: 8, marginBottom: 8, minWidth: 48 }}
                    onClick={() => {
                      if (!isSelected)
                        setNewSubPorts([...newSubPorts, subPortNum]);
                    }}
                  >
                    {isSelected ? `SP: ${subPortNum}` : `SP: ${subPortNum}`}
                  </Button>
                );
              })}
            </Box>
            <Box display="flex" flexWrap="wrap" mb={2}>
              {newSubPorts.map((subPort) => {
                const selectedPorts =
                  newPorts[subPort] ||
                  Array.from({ length: 64 }, (_, i) => (i + 1).toString());
                const allPorts = Array.from({ length: 64 }, (_, i) =>
                  (i + 1).toString()
                );
                const isAllSelected = selectedPorts.length === 64;
                return (
                  <span
                    key={subPort}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: 8,
                      marginBottom: 8,
                    }}
                  >
                    <Chip
                      label={`SP: ${subPort} | ${selectedPorts.length}`}
                      onClick={(e) => {
                        setPortMenusAnchor({
                          ...portMenusAnchor,
                          [subPort]: e.currentTarget,
                        });
                        setPortMenusOpen(subPort);
                      }}
                      onDelete={() => {
                        setNewSubPorts(
                          newSubPorts.filter((sp) => sp !== subPort)
                        );
                        setNewPorts((prev) => {
                          const updated = { ...prev };
                          delete updated[subPort];
                          return updated;
                        });
                        setNewSubPortLimits((prev) => {
                          const updated = { ...prev };
                          delete updated[subPort];
                          return updated;
                        });
                      }}
                      color="primary"
                      style={{ cursor: "pointer", marginRight: 4 }}
                      clickable
                    />
                    <Menu
                      anchorEl={portMenusAnchor[subPort]}
                      keepMounted
                      open={portMenusOpen === subPort}
                      onClose={() => setPortMenusOpen("")}
                      PaperProps={{ style: { maxHeight: 400, width: 180 } }}
                    >
                      <MenuItem>
                        <Button
                          color="primary"
                          variant="contained"
                          fullWidth
                          onClick={() => {
                            setNewPorts((prev) => ({
                              ...prev,
                              [subPort]: isAllSelected ? [] : allPorts,
                            }));
                          }}
                        >
                          {isAllSelected ? "Remove All" : "Select All"}
                        </Button>
                      </MenuItem>
                      <Divider />
                      <Box
                        px={2}
                        py={1}
                        style={{
                          maxHeight: 300,
                          overflowY: "auto",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          width: 140,
                        }}
                      >
                        <FormGroup>
                          {allPorts.map((port, i) => (
                            <FormControlLabel
                              key={port}
                              value={port}
                              control={
                                <Checkbox
                                  checked={selectedPorts.includes(port)}
                                  onChange={() => {
                                    setNewPorts((prev) => {
                                      const prevPorts =
                                        prev[subPort] || allPorts;
                                      let updated;
                                      if (prevPorts.includes(port)) {
                                        updated = prevPorts.filter(
                                          (p) => p !== port
                                        );
                                      } else {
                                        updated = [...prevPorts, port];
                                      }
                                      return { ...prev, [subPort]: updated };
                                    });
                                  }}
                                  color="primary"
                                />
                              }
                              label={`Port - ${port}`}
                            />
                          ))}
                        </FormGroup>
                      </Box>
                    </Menu>
                  </span>
                );
              })}
            </Box>
            <TextField
              select
              label="SBLU"
              value={
                newSubPorts.length === 1
                  ? "Inactive"
                  : typeof newSblu === "undefined"
                  ? newSubPorts.length > 1
                    ? "Active"
                    : "Inactive"
                  : newSblu
                  ? "Active"
                  : "Inactive"
              }
              onChange={(e) => setNewSblu(e.target.value === "Active")}
              fullWidth
              margin="normal"
              SelectProps={{ native: true }}
              required
              disabled={newSubPorts.length === 0 || newSubPorts.length === 1}
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </TextField>
            <TextField
              type="number"
              label="SBLU Trigger In"
              value={newSbluTriggerIn}
              onChange={(e) => setNewSbluTriggerIn(e.target.value)}
              fullWidth
              margin="normal"
              required
              disabled={
                newSubPorts.length === 0 ||
                newSubPorts.length === 1 ||
                !(typeof newSblu === "undefined"
                  ? newSubPorts.length > 1
                  : newSblu)
              }
              inputProps={{ min: 1, step: 1 }}
              error={
                (typeof newSblu === "undefined"
                  ? newSubPorts.length > 1
                  : newSblu) && !isPositiveInteger(newSbluTriggerIn)
              }
              helperText={
                (typeof newSblu === "undefined"
                  ? newSubPorts.length > 1
                  : newSblu) && !isPositiveInteger(newSbluTriggerIn)
                  ? "Enter a positive integer"
                  : ""
              }
            />
            <TextField
              type="number"
              label="Global Limit"
              value={newGlobalLimit}
              onChange={(e) => setNewGlobalLimit(e.target.value)}
              fullWidth
              margin="normal"
              required
              inputProps={{ min: 1, step: 1 }}
              error={!isPositiveInteger(newGlobalLimit)}
              helperText={
                !isPositiveInteger(newGlobalLimit)
                  ? "Enter a positive integer"
                  : ""
              }
            />
            <TextField
              type="number"
              label="Full Day Limit"
              value={newFullDayLimit}
              onChange={(e) => setNewFullDayLimit(e.target.value)}
              fullWidth
              margin="normal"
              required
              inputProps={{ min: 1, step: 1 }}
              error={!isPositiveInteger(newFullDayLimit)}
              helperText={
                !isPositiveInteger(newFullDayLimit)
                  ? "Enter a positive integer"
                  : ""
              }
            />
            {newSubPorts.length > 0 && (
              <Box
                mt={2}
                p={1.5}
                component={Paper}
                elevation={0}
                style={{
                  border: "1px solid #e3e8f4",
                  borderRadius: 10,
                  background: "#f8fbff",
                }}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  flexWrap="wrap"
                  mb={1}
                >
                  <Box>
                    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
                      SubPort Limit Overrides
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      Leave blank to use the box defaults.
                    </Typography>
                  </Box>
                </Box>
                {newSubPorts.map((subPort) => {
                  const limits = newSubPortLimits[subPort] || {};
                  return (
                    <Box
                      key={subPort}
                      display="flex"
                      alignItems="flex-end"
                      gridGap={10}
                      mb={1}
                      p={1}
                      style={{
                        border: "1px solid #e8edf7",
                        borderRadius: 8,
                        background: "#fff",
                      }}
                    >
                      <Box
                        minWidth={46}
                        height={38}
                        display="flex"
                        alignItems="center"
                        fontWeight={700}
                        style={{
                          color: "#3f51b5",
                        }}
                      >
                        {`SP ${subPort}`}
                      </Box>
                      <TextField
                        type="number"
                        label="Global"
                        value={limits.globalLimit || ""}
                        onChange={(e) =>
                          setNewSubPortLimits((prev) => ({
                            ...prev,
                            [subPort]: {
                              ...(prev[subPort] || {}),
                              globalLimit: e.target.value.replace(/[^\d]/g, ""),
                            },
                          }))
                        }
                        placeholder={`${newGlobalLimit}`}
                        margin="dense"
                        size="small"
                        fullWidth
                        inputProps={{ min: 1, step: 1 }}
                      />
                      <TextField
                        type="number"
                        label="Full Day"
                        value={limits.fullDayLimit || ""}
                        onChange={(e) =>
                          setNewSubPortLimits((prev) => ({
                            ...prev,
                            [subPort]: {
                              ...(prev[subPort] || {}),
                              fullDayLimit: e.target.value.replace(/[^\d]/g, ""),
                            },
                          }))
                        }
                        placeholder={`${newFullDayLimit}`}
                        margin="dense"
                        size="small"
                        fullWidth
                        inputProps={{ min: 1, step: 1 }}
                      />
                    </Box>
                  );
                })}
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={closeAddDialog}
              color="secondary"
              variant="contained"
            >
              Cancel
            </Button>
            <Button onClick={handleAddBox} color="primary" variant="contained">
              Add
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={showReorderDialog}
          onClose={() => setShowReorderDialog(false)}
        >
          <DialogTitle>Reorder PRC Boxes</DialogTitle>
          <DialogContent>
            <DialogContentText>
              ⚠️ Reordering will delete and re-add all PRC boxes. This may cause
              message sending mismatches with the PRC config.
              <br />
              <b>Best practice:</b> Only use this when not sending messages, and
              consider using "Reset PRC Config" first.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setShowReorderDialog(false)}
              color="secondary"
              disabled={reorderLoading}
            >
              Cancel
            </Button>
            <Button
              onClick={handleConfirmReorder}
              color="primary"
              variant="contained"
              disabled={reorderLoading}
            >
              {reorderLoading ? "Reordering..." : "Confirm & Reorder"}
            </Button>
          </DialogActions>
        </Dialog>
        {/* Confirm Dialog */}
        <ConfirmDialog
          open={confirmDialog.open}
          title={confirmDialog.title}
          content={confirmDialog.content}
          onConfirm={handleDoConfirm}
          onCancel={handleCloseConfirm}
        />
      </>
    );
  } else {
    return (
      <>
        <ProgrssBar />
        <h1>Please Wait...</h1>
      </>
    );
  }
};

export default SlimsPrc;
